var _circle, _path, _rect, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgLfAchivement = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  className: "dd-privacy-hidden"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 12,
  r: 12,
  fill: "#fff"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9 16.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5Z",
  fill: "#405B73"
})), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  x: 7.5,
  y: 17,
  width: 9,
  height: 4,
  rx: 0.7,
  fill: "#405B73"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9 18.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5Z",
  fill: "#B0D3F0"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.254 4a.75.75 0 0 0-.75.75v.42c-1.26.085-2.345 1.32-1.904 2.756l.195.633c.261.848.978 1.476 1.853 1.621l1.287.215.069.105c.532.799 1.348 1.456 1.995 1.895a6.774 6.774 0 0 1-1.186 3.163l-.31.442h5l-.309-.442a6.774 6.774 0 0 1-1.186-3.163c.647-.44 1.463-1.096 1.996-1.895l.056-.086 1.403-.234a2.341 2.341 0 0 0 1.853-1.62l.195-.634c.454-1.475-.705-2.74-2.007-2.76V4.75a.75.75 0 0 0-.75-.75h-7.5Zm.103 5.285c-.569-1.316-.853-2.722-.853-3.035v-.072c-.64.079-1.175.717-.948 1.454l.195.633c.15.486.56.845 1.062.929l.544.09Zm7.942-.091-.657.11c.574-1.322.862-2.74.862-3.054v-.08c.685.019 1.29.685 1.051 1.462l-.195.633c-.149.486-.56.845-1.061.929Z",
  fill: "#F4CC54"
})));
export default SvgLfAchivement;